import { FormatDeliveryDate, Text } from '@wyz/ui';
import { DateUtils, OFFER_TYPE, ORDER_TYPE_CODE } from '@wyz/utils';
import { Trans, useLocale } from '~/common/context';
import { IQuoteStock } from '~/purchase/types';

type Props = {
  stocks: IQuoteStock[];
  currency: string;
};

function StocksTable({ stocks, currency }: Props) {
  const locale = useLocale();

  return (
    <table className='w-100'>
      <thead>
        <tr>
          <th className='text-center'>
            <Text heading='xs' weight='semi-bold' color='secondary-gray'>
              <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.source' />
            </Text>
          </th>
          <th className='text-center'>
            <Text heading='xs' weight='semi-bold' color='secondary-gray'>
              <Trans i18nKey='app.common.quantity' />
            </Text>
          </th>
          <th className='text-center'>
            <Text heading='xs' weight='semi-bold' color='secondary-gray'>
              <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.margin' />
            </Text>
          </th>
          <th className='text-center'>
            <Text heading='xs' weight='semi-bold' color='secondary-gray'>
              <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.buying_price' />
            </Text>
          </th>
          <th className='text-center w-20'>
            <Text heading='xs' weight='semi-bold' color='secondary-gray'>
              <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.delay' />
            </Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {stocks.map((stock, index) => (
          <tr key={index}>
            <td>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {stock.supplierName}
              </Text>
            </td>
            <td className='text-center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {stock.quantity}
              </Text>
            </td>
            <td className='text-center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {stock.offerType === OFFER_TYPE.LOCAL_STOCK
                  ? '-'
                  : locale.formatters.money(stock.margin, {
                      fallback: '-',
                      currency: currency,
                    })}
              </Text>
            </td>
            <td className='text-center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {stock.offerType === OFFER_TYPE.LOCAL_STOCK
                  ? '-'
                  : locale.formatters.money(stock.buyingPrice, {
                      fallback: '-',
                      currency: currency,
                    })}
              </Text>
            </td>
            <td className='text-center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {stock.deliveryDate ? (
                  <FormatDeliveryDate
                    orderType={stock.backOrder ? ORDER_TYPE_CODE.BO : null}
                    backorderContent={
                      <Trans i18nKey='app.common.offer_type.backorder' />
                    }
                    date={stock.deliveryDate}
                    format={DateUtils.DATE_FORMAT.DM}
                    locale={locale.locale}
                  />
                ) : (
                  '/'
                )}
              </Text>
            </td>
            <td></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default StocksTable;
